import React from 'react'
import { useTranslation } from 'react-i18next'

import { FloatingMenuItem } from '../../../../../../packages/kiti/components/navigation/FloatingMenu'
import { useChecklistForm, useChecklistFormActions, useSelectedQuestion } from '../../../_form/ChecklistFormHandler'
import Line from '../../../../../../packages/kiti/components/helpers/Line'

const checkIfcanHaveConditions = question => {
  const type = question.questionType?.name
  if (type === 'checkbox') return !question.childDisplayConditions?.length
  if (['select', 'multiple'].includes(type)) return !!question.options?.length
  if (['numeric', 'float', 'place', 'calc'].includes(type)) return true

  return false
}

const useOnAddConditions = question => {
  const { addChildConditionsToSelectedQuestion, openConditionsModal } = useChecklistFormActions()

  if (question.questionType?.name === 'checkbox') {
    return () =>
      addChildConditionsToSelectedQuestion([
        [{ field: 'value', operator: 'eq', value: true }],
        [{ field: 'value', operator: 'eq', value: false }]
      ])
  }

  return openConditionsModal
}

const AddConditionsMenuItem = () => {
  const { t } = useTranslation('editChecklist')
  const form = useChecklistForm()
  const selectedQuestion = useSelectedQuestion()
  const onAddConditions = useOnAddConditions(selectedQuestion)

  const canHaveConditions = checkIfcanHaveConditions(selectedQuestion)
  if (!canHaveConditions) return false

  // Bulk execution is incompatible with conditional logic between questions (backend rejects it),
  // so the action stays visible but disabled while allowBulkExecution is enabled, with a tooltip
  // explaining why — the user should still see the action exists, just unavailable.
  const isBlockedByBulkExecution = form.allowBulkExecution

  return (
    <>
      <FloatingMenuItem
        onClick={onAddConditions}
        label={t('addLogic')}
        icon="BsToggles"
        color="primary"
        disabled={isBlockedByBulkExecution}
        tooltip={isBlockedByBulkExecution ? t('addLogicBlockedByBulkExecution') : undefined}
      />
      <Line />
    </>
  )
}

export default AddConditionsMenuItem
